import React from "react";
import { BsChatDotsFill } from "react-icons/bs";
import styles from "./Styles/ChatSection.module.css";
import { getDownloadLink } from "../../utils/appLinks";

const ChatSection: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.chatBox}>
          <div className={styles.channel}># Main-Channel</div>

          <div className={`${styles.message} ${styles.messageRight}`}>
            <div className={styles.messageBubbleBlue}>
              How will the rocket grow?
            </div>
            <div className={styles.avatar}>Y</div>
          </div>

          <div className={`${styles.message} ${styles.messageLeft}`}>
            <div className={styles.avatar}>S</div>
            <div className={styles.messageBubbleLight}>
              How do I greet you?
            </div>
          </div>
        </div>

        <div className={styles.ticket}>
          <div className={styles.ticketLeft}>
            <span className={styles.ticketNumber}>082</span>
          </div>

          <div className={styles.ticketDivider} />

          <div className={styles.ticketRight}>
            <h3>Art Exhibition</h3>
            <p>
              <strong>Monday</strong>
            </p>
            <p>08.00 AM - 09.00 PM</p>
          </div>

          <div className={styles.ticket_date}>
            <h3 className={styles.ticket_text}>18</h3>
            <p className={styles.ticket_text}>Jul</p>
          </div>
        </div>
      </div>

      <div className={styles.right}>
        <span className={styles.eyebrow}>Community chat</span>
        <h2>
          Start a great <br />
          <span className={styles.highlight}>conversation</span> today
        </h2>
        <p>
          Connect with others through our chat section, share your thoughts,
          express your passion, and engage with people from around the
          world.
        </p>

        <div className={styles.chatFeature}>
          <span className={styles.chatFeatureIcon}>
            <BsChatDotsFill size={18} />
          </span>
          <span>
            <strong>Equipped with a chat feature</strong> that helps you
            communicate with other people, in real time.
          </span>
        </div>

          <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer">
        <button className={styles.ctaButton}>
            Start chatting →
        </button>
          </a>
      </div>
    </div>
  );
};

export default ChatSection;